/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {
  var $window = $(window),
      $body = $('body'),
      $windowHeight = $window.height(),
      $windowWidth = $window.width(),
      $scrollTop = $window.scrollTop(),
      $isMobile = ($windowWidth < 768) ? true : false;

  /* update resolution values */
  function windowResize() {
    $windowHeight = $window.height();
    $windowWidth = $window.width();
    $isMobile = ($windowWidth < 768) ? true : false;
  }

  /* update scroll position */
  function windowScroll() {
    $scrollTop = $window.scrollTop();
  }

  /* form validation */
  function validEmail(email) {
    if(email.length>0) {
      var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      if(emailPattern.test(email) === false) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  function checkNum(num) {
    var pattern = new RegExp(/(^-?\d\d*\.\d*$)|(^-?\d\d*$)|(^-?\.\d\d*$)/);
    return pattern.test(num);
  }

  /* formatting */
  function addCommas(nStr) {
    nStr += '';
    x = nStr.split('.');
    x1 = x[0];
    x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    return x1 + x2;
  }

  function isImage($url) {
    return($url.match(/\.(apng|avif|gif|jpg|jpeg|jfif|pjpeg|pjp|png|svg|webp)$/) != null);
  }

  function adjustZoomGallery() {
    var $zoomGalleryRatio = 990/1320,
        $zoomGalleryWidth = $('.gallery-overlay .overlay-content').width(),
        $zoomGalleryHeight = $('.gallery-overlay .overlay-content').width(),
        $windowRatio = $windowHeight/$windowWidth;

    //if($windowWidth<$zoomGalleryWidth+40 || $windowHeight<$zoomGalleryHeight+40) {
      if($windowRatio>$zoomGalleryRatio) {
        $zoomGalleryWidth = $windowWidth-40;
        $zoomGalleryHeight = Math.floor($zoomGalleryWidth*$zoomGalleryRatio);
      } else {
        $zoomGalleryHeight = $windowHeight-40;
        $zoomGalleryWidth = Math.floor((1/$zoomGalleryRatio)*$zoomGalleryHeight);
      }

      if($zoomGalleryWidth > 1320 || $zoomGalleryHeight > 990) {
        $zoomGalleryHeight = 990;
        $zoomGalleryWidth = 1320;
      }

      $('.gallery-overlay .overlay-content').css({ width:$zoomGalleryWidth, height:$zoomGalleryHeight, marginTop:-($zoomGalleryHeight/2), marginLeft:-($zoomGalleryWidth/2) });
      //$('#zoom-gallery .swiper-container, #zoom-gallery .swiper-slide, #zoom-gallery iframe').css({ width:$zoomGalleryWidth, height:$zoomGalleryHeight });
    //}
  }

  /* fix landing page swiper arrow position */
  function adjustSwiperArrows() {
    if($isMobile) {
      $('.listings-swiper, .listing-swiper').each(function() {
        var $swiper = $(this),
            $top = ($swiper.find('.swiper-slide img').first().outerHeight()/2) - 15;

        $swiper.find('.swiper-button-prev, .swiper-button-next').css({ top:$top });
      });
    }
  }

  function checkListingsSidebar() {
    if($isMobile) {
      $('ul.listings + hr').before($('.related-insights'));
    } else {
      $('.listings-content .sidebar').append($('.related-insights'));
    }
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        $window.resize(windowResize);
        $window.scroll(windowScroll);

        /* search */
        $('a.search-toggle').click(function(e) {
          e.preventDefault();

          if(!$isMobile && !$body.hasClass('search')) {
            $body.removeClass('contact-open');

            if($body.hasClass('search-open')) {
              $body.removeClass('search-open');
            } else {
              $body.addClass('search-open');
              $('.header-search input[type="search"').focus();
            }
          }
        });
        $('.search-mask, .header-search .close').click(function(e) {
          e.preventDefault();
          
          $body.removeClass('search-open');
        });

        /* contact */
        $('.nav li.contact a').click(function(e) {
          e.preventDefault();

          if(!$isMobile && !$('.nav li.contact').hasClass('current-menu-item')) {
            $body.removeClass('search-open');

            if($body.hasClass('contact-open')) {
              $body.removeClass('contact-open');
            } else {
              $body.addClass('contact-open');
            }
          }
        });
        $('.contact-mask, .header-contact .close').click(function(e) {
          e.preventDefault();
          
          $body.removeClass('contact-open');
        });

        /* contact - form submission */
        $('#contact-form').submit(function(e) {
          e.preventDefault();

          $('#contact-form button[type="submit"]').attr('disabled', true);

          // validation
          $('#contact-form .msg, #contact-form .error-msg').html('');
          $('#contact-form .error').removeClass('error');

          var $isValid = true;

          if($('#contact-form input[name="first_name"]').val()==='') {
            $isValid = false;
            $('#contact-form input[name="first_name"]').addClass('error')
              .next().html('You must enter your first name.');
          }
          if($('#contact-form input[name="last_name"]').val()==='') {
            $isValid = false;
            $('#contact-form input[name="last_name"]').addClass('error')
              .next().html('You must enter your last name.');
          }
          if($('#contact-form input[name="email"]').val()==='') {
            $isValid = false;
            $('#contact-form input[name="email"]').addClass('error')
              .next().html('You must enter your email.');
          } else if(!validEmail($('#contact-form input[name="email"]').val())) {
            $isValid = false;
            $('#contact-form input[name="email"]').addClass('error')
              .next().html('You must enter a valid email address.');
          }
          if($('#contact-form input[name="phone"]').val()==='') {
            $isValid = false;
            $('#contact-form input[name="phone"]').addClass('error')
              .next().html('You must enter your phone number.');
          }

          if($isValid) {
            var $action = $(this).attr('action'),
                $data = $(this).serialize();

            var $scrollTo = 0;
            if(!$body.hasClass('contact-open')) {
              $scrollTo = $('.form-content').offset().top-40;
            }
            TweenLite.to(window, 0.4, {scrollTo:$scrollTo});


            $('#contact-form button[type="submit"]').addClass('sending');

            $.ajax({
              url: $action,
              type: 'POST',
              data: $data,
              dataType: 'json',
              success: function(data) {
                if(data.success===true) {
                  //reset form fields
                  //$('#contact-form input[type="text"], #contact-form input[type="email"], #contact-form textarea').val('');
                  //$('#contact-form input[type="checkbox"]').attr('checked', null);
                  $('#contact-form .msg').html('<p>'+data.message+'</p>');
                  document.getElementById('contact-form').reset();
                } else {
                  $('#contact-form .msg').html('<p class="error">'+data.message+'</p>');
                }

                $('#contact-form button[type="submit"]').removeClass('sending');
                $('#contact-form button[type="submit"]').removeAttr('disabled');
              },
              error: function() {
                $('#contact-form .msg').html('<p class="error">An error has occured. Please try again later.</p>');
                $('#contact-form button[type="submit"]').removeClass('sending');
                $('#contact-form button[type="submit"]').removeAttr('disabled');
              }
            });
          } else {
            $('#contact-form button[type="submit"]').removeAttr('disabled');

            var $scrollTo = 0;
            if(!$body.hasClass('contact-open')) {
              $scrollTo = $('.form-content').offset().top-40;
            }
            TweenLite.to(window, 0.4, {scrollTo:$scrollTo});
          }

          return false;
        });

        /* newsletter - form submission */
        /*$('#newsletter-form').submit(function(e) {
          e.preventDefault();

          // validation
          $('#newsletter-form .msg, #newsletter-form .error-msg').html('');
          $('#newsletter-form .error').removeClass('error');

          var $isValid = true;

          if($('#newsletter-form input[name="email"]').val()==='') {
            $isValid = false;
            $('#newsletter-form input[name="email"]').addClass('error')
              .next().html('You must enter your email.');
          } else if(!validEmail($('#newsletter-form input[name="email"]').val())) {
            $isValid = false;
            $('#newsletter-form input[name="email"]').addClass('error')
              .next().html('You must enter a valid email address.');
          }

          if($isValid) {
            var $action = $(this).attr('action'),
                $data = $(this).serialize();

            $.ajax({
              url: $action,
              type: 'POST',
              data: $data,
              dataType: 'json',
              success: function(data) {
                if(data.success===true) {
                  $('#newsletter-form .msg').html('<p>'+data.message+'</p>');
                } else {
                  $('#newsletter-form .msg').html('<p class="error">'+data.message+'</p>');
                }

                setTimeout(function() {
                  $('.newsletter-overlay').fadeOut();
                }, 4000);
              },
              error: function() {
                $('#newsletter-form .msg').html('<p class="error">An error has occured. Please try again later.</p>');

                setTimeout(function() {
                  $('.newsletter-overlay').fadeOut();
                }, 4000);
              }
            });
          }

          return false;
        });*/

        /* lazyload */
        var $lazyload = new LazyLoad({
          elements_selector:'.lazy'
        });

        /* market insights masonry */
        if($('.masonry').length > 0) {
          var $masonry = $('.masonry').masonry({
            itemSelector:'.post-item',
            transitionDuration:0,
            percentPosition:true
          });
          $('.masonry').imagesLoaded(function() {
            $masonry.masonry('reloadItems');
            $masonry.masonry('layout');
          });
          
          $masonry.on('layoutComplete', function() {
            var $lazyload = new LazyLoad({
              elements_selector:'.lazy'
            });
          });

          /* market insights pagination */
          $('.pagination:not(.search-pagination)').on('click', 'a', function(e) {
            e.preventDefault();

            var $nextLink = $(this);
            if($nextLink.hasClass('loading')) {
              return false;
            }
            $nextLink.addClass('loading');
            $('<div>').load($nextLink.attr('href') + " .market-insights-content", function() {
              var $div = $(this),
                  $posts = $div.find('article.post'),
                  $paginationLink = $div.find('.pagination a');

              $('.masonry').append($posts).imagesLoaded(function() {
                $masonry.masonry('reloadItems');
                $masonry.masonry('layout');
              });

              if($paginationLink.length>0) {
                $('.pagination a').remove();
                $('.pagination').append($paginationLink);
              } else {
                $('.pagination').remove();
              }
            });
          });
        }

        /* mobile navigation */
        $('a.menu-toggle').click(function(e) {
          e.preventDefault();

          $('.mobile-menu').fadeIn();
        });
        $('.mobile-menu a.close').click(function(e) {
          e.preventDefault();

          $('.mobile-menu').fadeOut();
        });

        /* listings swiper */
        if($('.listings-swiper').length > 0) {
          var $listingsSwiper = new Swiper('.listings-swiper', {
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            on: {
              init: function() {
                adjustSwiperArrows();

                $lazyload = new LazyLoad({
                  elements_selector:'.lazy'
                });
              },
              imagesReady: function() {
                adjustSwiperArrows();
              },
              resize: function() {
                adjustSwiperArrows();
              }
            }
          });

          $window.resize(function() {
            $listingsSwiper.update();
          });
        }

        /* sticky cta */
        if($('.cta-newsletter').length > 0) {
          $window.scroll(function() {
            var $maxTop = 0,
                $maxBottom = ($('.footer').offset().top - $windowHeight);
            /*if($('.home-feature').length>0) {
              $maxTop = $('.home-feature').outerHeight();
            } else if($('.page-feature').length>0) {
              $maxTop = $('.page-feature').offset().top + $('.page-feature').outerHeight();
            }*/

            if($scrollTop > $maxTop) {// && $scrollTop < $maxBottom) {
              $('.cta-newsletter').addClass('show-cta');
            } else {
              $('.cta-newsletter').removeClass('show-cta');
            }
          });

          if(typeof(Storage) !== 'undefined') {
            if(localStorage.getItem('hide-cta')) {
              $('.cta-newsletter').addClass('hide-cta');
            }
          }

          $('.cta-newsletter .close').click(function(e) {
            e.preventDefault();

            $('.cta-newsletter').addClass('hide-cta');

            if(typeof(Storage) !== 'undefined') {
              localStorage.setItem('hide-cta', true);
            }
          });

          /*$('.cta-newsletter a').click(function(e) {
            e.preventDefault();

            $('.newsletter-overlay').fadeIn();
          });
          $('.newsletter-overlay .mask, .newsletter-overlay a.close').click(function(e) {
            e.preventDefault();

            $('.newsletter-overlay').fadeOut();
          });*/

          /* contact links */
          $('.cta-newsletter a.button').click(function(e) {
            if(!$isMobile) {
              e.preventDefault();

              TweenLite.to(window, 0, {scrollTo:0});
              $body.removeClass('search-open');

              if($body.hasClass('contact-open')) {
                $body.removeClass('contact-open');
              } else {
                $body.addClass('contact-open');
              }
            }
          });
        }

        /* back to top */
        $('.back-to-top').click(function(e) {
          e.preventDefault();

          TweenLite.to(window, 1, {scrollTo:0});
        });
      }
    },
    'home': {
      init: function() {
        /* display random feature insight */
        var $featureInsights = $('.feature-insight'),
            $random = Math.floor(Math.random()*$featureInsights.length);
        $featureInsights.eq($random).show();

        $('.home-feature img').imagesLoaded(function() {
          $('.home-feature img').animate({ opacity:1 });
        });

        /* skrollr */
        if($('.skrollable').length>0) {
          var $s = skrollr.init({
            forceHeight:false
          });
          if($s.isMobile()) {
            $s.destroy();
          }
        }

        /* home cta videos */
        var $videoSlidesInterval = false;
        $('.home-callouts a.callout').hover(function() {
          if(!$isMobile) {
            if($(this).find('video').length > 0) {
              $(this).find('video')[0].play();
            } else if($(this).find('.video-slides').length > 0) {
              var $slides = $(this).find('.video-slides');
              $slides.find('img').first().addClass('active-slide');

              $videoSlidesInterval = setInterval(function() {
                var $activeSlide = $slides.find('.active-slide').removeClass('active-slide');
                if($activeSlide.next().length > 0) {
                  $activeSlide.next().addClass('active-slide');
                } else {
                  $slides.find('img').first().addClass('active-slide');
                }
              }, 4000);
            }
          }
        }, function() {
          if($(this).find('video').length > 0) {
            $(this).find('video')[0].pause();
          } else if($videoSlidesInterval) {
            clearInterval($videoSlidesInterval);
            $(this).find('.video-slides .active-slide').removeClass('active-slide');
          }
        });
      }
    },
    'page_template_template_listings': {
      init: function() {
        if($isMobile) {
          $('.page-feature .video-wrapper').remove();
        } else {
          $('.page-feature .video-wrapper video')[0].play();
        }

        /* contact links */
        $('a.contact-cta').click(function(e) {
          if(!$isMobile) {
            e.preventDefault();

            TweenLite.to(window, 0, {scrollTo:0});
            $body.removeClass('search-open');

            if($body.hasClass('contact-open')) {
              $body.removeClass('contact-open');
            } else {
              $body.addClass('contact-open');
            }
          }
        });

        checkListingsSidebar();
        $window.resize(checkListingsSidebar);
      }
    },
    'page_template_template_past_sales': {
      init: function() {
        /* contact links */
        $('a.contact-cta').click(function(e) {
          if(!$isMobile) {
            e.preventDefault();

            TweenLite.to(window, 0, {scrollTo:0});
            $body.removeClass('search-open');

            if($body.hasClass('contact-open')) {
              $body.removeClass('contact-open');
            } else {
              $body.addClass('contact-open');
            }
          }
        });

        checkListingsSidebar();
        $window.resize(checkListingsSidebar);
      }
    },
    'single_listing': {
      init: function() {
        /* update breadcrumbs and post navigation */
        var $referrer = document.referrer,
            $breadcrumbs = $('#breadcrumbs').html(),
            $post_navigation = $('.post-navigation').html();

        if($referrer.indexOf('apartment-buildings') !== -1) {
          $body.removeClass('commercial-property development-site').addClass('apartment-building');

          $breadcrumbs = $breadcrumbs.replace(/commercial-properties|development-sites/g, 'apartment-buildings');
          $breadcrumbs = $breadcrumbs.replace(/Commercial properties|Development sites/g, 'Apartment buildings');
          $('#breadcrumbs').html($breadcrumbs);

          $post_navigation = $post_navigation.replace(/commercial-properties|development-sites/g, 'apartment-buildings');
          $post_navigation = $post_navigation.replace(/commercial property|development site/g, 'apartment building');
          $('.post-navigation').html($post_navigation);
        } else if($referrer.indexOf('commercial-properties') !== -1) {
          $body.removeClass('apartment-building development-site').addClass('commercial-property');

          $breadcrumbs = $breadcrumbs.replace(/apartment-buildings|development-sites/g, 'commercial-properties');
          $breadcrumbs = $breadcrumbs.replace(/Apartment buildings|Development sites/g, 'Commercial properties');
          $('#breadcrumbs').html($breadcrumbs);
          
          $post_navigation = $post_navigation.replace(/apartment-buildings|development-sites/g, 'commercial-properties');
          $post_navigation = $post_navigation.replace(/apartment building|development site/g, 'commercial property');
          $('.post-navigation').html($post_navigation);
        } else if($referrer.indexOf('development-sites') !== -1) {
          $body.removeClass('apartment-building commercial-property').addClass('development-site');

          $breadcrumbs = $breadcrumbs.replace(/apartment-buildings|commercial-properties/g, 'development-sites');
          $breadcrumbs = $breadcrumbs.replace(/Apartment buildings|Commercial properties/g, 'Development sites');
          $('#breadcrumbs').html($breadcrumbs);
          
          $post_navigation = $post_navigation.replace(/apartment-buildings|commercial-properties/g, 'development-sites');
          $post_navigation = $post_navigation.replace(/apartment building|commercial property/g, 'development site');
          $('.post-navigation').html($post_navigation);
        }

        /* listing gallery */
        if($('.listing-swiper .swiper-slide').length>1) {
          var $listingSwiper = new Swiper('.listing-swiper', {
            loop: true,
            slidesPerView: 'auto',
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            pagination: {
              el: '.swiper-pagination',
              type: 'fraction',
            },
            breakpoints: {
              767: {
                spaceBetween: 10
              }
            },
            on: {
              init: function() {
                adjustSwiperArrows();
              },
              imagesReady: function() {
                adjustSwiperArrows();
              },
              resize: function() {
                adjustSwiperArrows();
              },
              transitionEnd: function() {
                if($('.listing-swiper .swiper-slide:not(.swiper-slide-duplicate)').length === 2) {
                  if(this.activeIndex === 0) {
                    this.slideTo(2, 0);
                  } else if(this.activeIndex === 3) {
                    this.slideTo(1, 0);
                  }
                }
              }
            }
          });
        } else {
          $('.listing-swiper .swiper-slide').addClass('swiper-slide-active');
          $('.listing-swiper .swiper-button-prev, .listing-swiper .swiper-button-next, .listing-swiper .swiper-pagination').remove();
        }

        /* zoom gallery */
        if($('.zoom-swiper .swiper-slide').length>1) {
          var $zoomSwiper = new Swiper('.zoom-swiper', {
            loop: true,
            slidesPerView: 'auto',
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          });
        } else {
          $('.zoom-swiper .swiper-button-prev, .zoom-swiper .swiper-button-next, .zoom-swiper .swiper-pagination').remove();
        }

        $('.gallery-overlay').imagesLoaded(function() {
          adjustZoomGallery();
        });

        $('a.swiper-zoom').click(function(e) {
          e.preventDefault();

          $('.gallery-overlay').fadeIn(function() {
            $('.gallery-overlay').imagesLoaded(function() {
              adjustZoomGallery();
            });
            adjustZoomGallery();
            if($zoomSwiper) {
              $zoomSwiper.update();
              $zoomSwiper.slideTo($listingSwiper.activeIndex, 0);
            }
            $('.gallery-overlay .overlay-content').animate({ opacity:1 });
          });
        });
        $('.gallery-overlay .mask, .gallery-overlay .close').click(function(e) {
          e.preventDefault();
          
          $('.gallery-overlay').fadeOut(function() {
            $('.gallery-overlay .overlay-content').css({ opacity:0 });
          });
        });

        adjustZoomGallery();
        $window.resize(adjustZoomGallery);

        /* hide/show suite mix columns */
        if($('td.suite-mix-units').length === 0) {
          $('.suite-mix-units').hide();
        }
        if($('td.suite-mix-size').length === 0) {
          $('.suite-mix-size').hide();
        }
        if($('td.suite-mix-rent').length === 0) {
          $('.suite-mix-rent').hide();
        }

        /* print */
        $('a.print').click(function(e) {
          e.preventDefault();

          $('.print-overlay').fadeIn();
        });
        $('.print-overlay .mask, .print-overlay a.close').click(function(e) {
          e.preventDefault();

          $('.print-overlay').fadeOut();
        });
        $('.print-overlay .button').click(function(e) {
          e.preventDefault();

          var $href = $(this).attr('href');
          if($href === '#no') {
            $body.addClass('no-gallery');
          } else {
            $body.removeClass('no-gallery');
          }
          $('.print-overlay').fadeOut(function() {
            window.print();
          });
        });

        /* overview overflow */
        if($('.listing-overview').outerHeight()>320) {
          $('.listing-overview').addClass('overflow');

          $('.read-more-wrapper a.button').click(function(e) {
            e.preventDefault();

            var $height = $('.overflow-wrapper').outerHeight();

            $('.listing-overview').animate({ height:$height}, function() {
              $(this).removeClass('overflow').css({ height:'auto' });
            });
          });
          $('.show-less-wrapper a.button').click(function(e) {
            e.preventDefault();

            var $height = 264;

            TweenLite.to(window, 0, {scrollTo:$('.listing-overview').offset().top});
            $('.listing-overview').animate({ height:$height}, function() {
              $(this).addClass('overflow');
            });
          });
        } else {
          $('.listing-overview').addClass('no-overflow');
        }

        /* mortgage calculator */
        $('a.mortgage-calculator').click(function(e) {
          e.preventDefault();

          var $price = $(this).data('price');
          $('#mortgage-calculator-form input[name="amount"]').val($price);
          $('.mortgage-calculator-overlay').fadeIn();
        });
        $('.mortgage-calculator-overlay .close, .mortgage-calculator-overlay .mask').click(function(e) {
          e.preventDefault();

          $('.mortgage-calculator-overlay').fadeOut();
        });
        $('#mortgage-calculator-form input[name="amount"], #mortgage-calculator-form input[name="rate"], #mortgage-calculator-form input[name="term"]').keyup(function() {
          var $num = $(this).val();

          if($num !== 0) {
            if(checkNum($num)) {
              $('#mortgage-calculator-form .msg').html('');
            } else {
              $('#mortgage-calculator-form .msg').html('<p class="error">Please enter digits and decimals only.</p>');
            }
          } else {
            $('#mortgage-calculator-form .msg').html('<p class="error">Please enter a value.</p>');
          }
        });
        $('#mortgage-calculator-form').submit(function(e) {
          e.preventDefault();

          var $amount, $rate, $term, $monthly_payment, $total, $temp_term, $temp_rate = 0;

          $amount = parseFloat($('#mortgage-calculator-form input[name="amount"]').val().replace(/,/gi,""));
          $rate = parseFloat($('#mortgage-calculator-form input[name="rate"]').val());
          $term = parseFloat($('#mortgage-calculator-form input[name="term"]').val());

          if(isNaN($amount) || isNaN($rate) || isNaN($term)) {
            $('#mortgage-calculator-form .msg').html('<p class="error">Please complete the form.</p>');
          } else {
            $temp_rate =  $rate / 1200;
            $temp_term = $term * 12;
            $monthly_payment = ($amount*($temp_rate*Math.pow(1+$temp_rate,$temp_term)))/(Math.pow(1+$temp_rate,$temp_term)-1);

            $('#mortgage').html('$' + addCommas($amount.toFixed(2)));
            $('#interest').html('[ ' + $rate.toFixed(2) + '% ]*');
            $('#amortized').html($term + ' years');
            $('#payments').html('$' + addCommas($monthly_payment.toFixed(2)));
            $('#mortgage-calculator-form .msg').html('');
            $('#calculation').slideDown();
          }
        });
        $('#mortgage-calculator-form .reset').click(function(e) {
          e.preventDefault();

          $('#mortgage-calculator-form input[name="amount"]').val('');
          $('#mortgage-calculator-form input[name="rate"]').val('');
          $('#mortgage-calculator-form input[name="term"]').val('');
          $('#mortgage-calculator-form .msg').html('');
          $('#calculation').slideUp();
        });

        /* mobile accordions */
        $('h4.accordion').click(function(e) {
          e.preventDefault();

          if($isMobile) {
            if($(this).hasClass('open')) {
              $(this).removeClass('open');
            } else {
              $(this).addClass('open');
            }
          }
        });

        /* contact links */
        $('a.contact-cta').click(function(e) {
          if(!$isMobile) {
            e.preventDefault();

            $('#contact-form input[name="listing_id"]').val($(this).data('listing-id'));

            TweenLite.to(window, 0, {scrollTo:0});
            $body.removeClass('search-open');

            if($body.hasClass('contact-open')) {
              $body.removeClass('contact-open');
            } else {
              $body.addClass('contact-open');
            }
          }
        });
      }
    },
    'company': {
      init: function() {
        $('a[href="#bio-overlay"]').click(function(e) {
          e.preventDefault();

          $(this).next().fadeIn();
        });
        $('.bio-overlay .mask, .bio-overlay a.close').click(function(e) {
          e.preventDefault();

          $('.bio-overlay').fadeOut();
        });
      }
    },
    'blog': {
      init: function() {
        /* reports */
        $('a.show-all').click(function(e) {
          e.preventDefault();

          $('ul.reports').each(function() {
            var $hidden = $(this).find('li.hidden');
            TweenMax.staggerTo($hidden, 0.1, { opacity:1, display:'block' }, 0.025);
          });
          $('a.show-all').css({ display:'none' });
          $('a.show-less').css({ display:'inline-block' });
        });
        $('a.show-less').click(function(e) {
          e.preventDefault();

          TweenLite.to(window, 0, {scrollTo:($('.market-insights-reports').offset().top-40)});
          $('ul.reports li.hidden').css({ opacity:0, display:'none' });
          $('a.show-all').css({ display:'inline-block' });
          $('a.show-less').css({ display:'none' });
        });
      }
    },
    'single_post': {
      init: function() {
        /* image gallery */
        var $index = 0;
        $('.entry-content img').each(function() {
          var $img = $(this);
          var $link = $img.closest('a');
          if($link.length && isImage($link.attr('href'))) {
            $link.addClass('gallery-item').attr('data-index', $index);
            if($img.hasClass('alignleft')) {
              $link.addClass('gallery-item--alignleft');
            } else if($img.hasClass('alignright')) {
              $link.addClass('gallery-item--alignright');
            } else if($img.hasClass('aligncenter')) {
              $link.addClass('gallery-item--aligncenter');
            }

            $link.append('<span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.48 17.65"><path fill="#FFF" d="m17.48 15.94-4.54-4.55a7.17 7.17 0 1 0-1.75 1.69l4.57 4.57zM2.13 7.21a5 5 0 1 1 5 5 5 5 0 0 1-5-5z"/></svg></span>');

            $('.gallery-overlay .swiper-wrapper').append('<div class="swiper-slide"><img src="'+$link.attr('href')+'" alt="'+$img.attr('alt')+'" /></div>');

            $index++;
          }
        });

        if($('.zoom-swiper .swiper-slide').length>1) {
          var $zoomSwiper = new Swiper('.zoom-swiper', {
            loop: true,
            slidesPerView: 'auto',
            autoHeight: true,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          });
        } else {
          $('.zoom-swiper .swiper-button-prev, .zoom-swiper .swiper-button-next, .zoom-swiper .swiper-pagination').remove();
        }

        $('.gallery-overlay').imagesLoaded(function() {
          adjustZoomGallery();
        });

        var $smallBP = window.matchMedia('(max-width: 767px)');
        $('a.gallery-item').click(function(e) {
          if($smallBP.matches) {
            return true;
          }

          e.preventDefault();

          var $index = $(this).attr('data-index');

          $('.gallery-overlay').fadeIn(function() {
            $('.gallery-overlay').imagesLoaded(function() {
              adjustZoomGallery();
            });
            adjustZoomGallery();
            if($zoomSwiper) {
              $zoomSwiper.update();
              $zoomSwiper.slideTo($index, 0);
            }
            $('.gallery-overlay .overlay-content').animate({ opacity:1 });
          });
        });
        $('.gallery-overlay .mask, .gallery-overlay .close').click(function(e) {
          e.preventDefault();

          $('.gallery-overlay').fadeOut(function() {
            $('.gallery-overlay .overlay-content').css({ opacity:0 });
          });
        });

        adjustZoomGallery();
        $window.resize(adjustZoomGallery);

        /* contact links */
        $('a[href="/contact/"]').click(function(e) {
          if(!$isMobile) {
            e.preventDefault();

            TweenLite.to(window, 0, {scrollTo:0});
            $body.removeClass('search-open');

            if($body.hasClass('contact-open')) {
              $body.removeClass('contact-open');
            } else {
              $body.addClass('contact-open');
            }
          }
        });
      }
    },
    'search': {
      init: function() {
        if($('.search-form input[type="search"]').val() === '') {
          $('.search-form input[type="search"]').focus();
        }

        $('ul.listings.search-results li:lt(3)').addClass('show-listing');
        $('.search-pagination a').click(function(e) {
          e.preventDefault();

          $('ul.listings.search-results li.show-listing').last().nextAll(':lt(3)').addClass('show-listing');

          if($('ul.listings.search-results li.show-listing').last().next().length===0) {
            $('.search-pagination').remove();
          }
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
